import React from 'react';
import styles from './ChecklistItem.module.css';
import type { ForemanItem } from '../../types/foreman';

interface ChecklistItemProps {
  item: ForemanItem;
}

const STATUS_ICONS: Record<string, string> = {
  ok: '\u2713',
  warn: '!',
  critical: '\u2716',
  info: 'i',
};

function getStatusClass(type: string): string {
  if (type === 'ok') return styles.ok;
  if (type === 'warn') return styles.warn;
  if (type === 'critical') return styles.critical;
  return styles.info;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ item }) => {
  const statusClass = getStatusClass(item.type);
  const icon = STATUS_ICONS[item.type] ?? STATUS_ICONS.info;

  return (
    <div className={`${styles.item} ${statusClass}`}>
      <span className={styles.icon}>{icon}</span>
      <span className={styles.text}>{item.text}</span>
    </div>
  );
};

export default ChecklistItem;
